import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { func } from "prop-types";
import cuid from "cuid";
import { SessionContext } from "../../components";
import { Transactions, Login, Uploader, Profile } from "..";

const ProtectedRoutes = ({ children }) => {
  const { token = null, isUploader } = useContext(SessionContext);

  return children([
    token && isUploader && (
      <Switch key={cuid()}>
        <Route path="/uploader" component={Uploader} />
        <Redirect to="/uploader" />
      </Switch>
    ),
    token && !isUploader && (
      <Switch key={cuid()}>
        <Route exact path="/transactions" component={Transactions} />
        <Route exact path="/profile" component={Profile} />
        <Redirect to="/transactions" />

      </Switch>
    ),
  ]);
};

ProtectedRoutes.propTypes = {
  children: func.isRequired,
};

const Routes = () => {
  return (
    <ProtectedRoutes>
      {(protectedRoutes) => (
        <Switch>
          {protectedRoutes}
          <Route exact path="/login" component={Login} />
          <Redirect to="/login" />
        </Switch>
      )}
    </ProtectedRoutes>
  );
};

export default Routes;
